import src from "IMAGE";
export default { src, width: 313, height: 280, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
